module.exports = __webpack_public_path__ + "static/media/landscape-2020.e1ba764b.svg";